import { getEscolas, type GetSchoolsParams } from '@/api/school/schoolApi';
import { createQuery } from '@/lib/adapters/react-query-adapter';
import { QueryKeys } from '@/lib/constants/query-keys';
import { type SchoolsResponse } from '@/schemas/school';

export const useSchools = createQuery<
  SchoolsResponse,
  GetSchoolsParams | undefined,
  [QueryKeys.SCHOOLS, GetSchoolsParams?]
>({
  key: (params) => [QueryKeys.SCHOOLS, params],
  queryFn: (params) => getEscolas(params ?? {}),
});
